// TODO: convert to String Literal Types
export enum Category {
  CancellationInsurance = 'stornokostenschutz',
  AllAroundInsurance = 'rundumschutz',
  HealthInsurance = 'krankenschutz',
  OneTimeInsurance = 'einmalversicherung',
  AnnualInsurance = 'jahresversicherung',
  Caravan = 'caravaning',
  Camping = 'camping',
}

export enum Payments {
  SEPA = 'SEPA-Lastschrift',
  Creditcard = 'Kreditkarte',
  Paypal = 'Paypal',
}
